import { getLocalStorage, setLocalStorage } from "./local-storage";
import { FileType } from "./file-utils";

export type RecentItem =
	| { type: "page"; key: string; title: string; path: string; timestamp: number }
	| { type: "client"; id: string; name: string; code: string | null; timestamp: number }
	| { type: "vendor"; orgId: string; name: string; timestamp: number }
	| { type: "job-request-form"; vendorOrgId: string; vendorName: string; formId: string; formTitle: string; timestamp: number };

export interface RecentFile {
	fileId: string;
	fileName: string;
	fileType: FileType;
	jobId: number | null;
	clientId: string | null;
	timestamp: number;
}

const RECENTS_KEY = "dentlab-recents";
const MAX_RECENTS = 10;

const RECENT_FILES_KEY = "dentlab-recent-files";
const MAX_RECENT_FILES = 8;

function getDedupeKey(item: RecentItem): string {
	switch (item.type) {
		case "page": return `page:${item.key}`;
		case "client": return `client:${item.id}`;
		case "vendor": return `vendor:${item.orgId}`;
		case "job-request-form": return `job-request-form:${item.vendorOrgId}:${item.formId}`;
	}
}

export function addRecent(item: RecentItem): void {
	const existing = getLocalStorage<RecentItem[]>(RECENTS_KEY, []);
	const key = getDedupeKey(item);
	const filtered = existing.filter((e) => getDedupeKey(e) !== key);
	const updated = [item, ...filtered].slice(0, MAX_RECENTS);
	setLocalStorage(RECENTS_KEY, updated);
}

export function getRecents(): RecentItem[] {
	return getLocalStorage<RecentItem[]>(RECENTS_KEY, []);
}

export function addRecentFile(file: RecentFile): void {
	const existing = getLocalStorage<RecentFile[]>(RECENT_FILES_KEY, []);
	const filtered = existing.filter((e) => e.fileId !== file.fileId);
	const updated = [file, ...filtered].slice(0, MAX_RECENT_FILES);
	setLocalStorage(RECENT_FILES_KEY, updated);
}

export function getRecentFiles(): RecentFile[] {
	return getLocalStorage<RecentFile[]>(RECENT_FILES_KEY, []);
}
